export default __webpack_public_path__ + "static/media/usd.8f4afe9f.png";